<template>
  <v-container>
    <ValidationObserver v-slot="{ handleSubmit }">
    <v-tabs v-model="tabIndex">
      <v-tab v-for="item in items" :key="item.id" :disabled="isCreate && item.id == 3 ? true : false">{{ item.tab }}</v-tab>
    </v-tabs>
    <v-tabs-items class="tab-content" v-model="tabIndex">
      <v-tab-item active>
        <subject-content class="tab-detail" :subject="detailSubject" :isNew="isCreate"></subject-content>
      </v-tab-item>
      <v-tab-item>
        <subject-seo class="tab-detail" :subject="detailSubject"></subject-seo>
      </v-tab-item>
      <v-tab-item>
        <subject-seo-en class="tab-detail" :subject="detailSubject"></subject-seo-en>
      </v-tab-item>
    </v-tabs-items>
    <v-row v-if="isCreate" class="align-center justify-center ma-0 pt-5">
      <v-btn color="primary" width="130" @click="handleSubmit(saveSubject)">Tạo môn học</v-btn>
    </v-row>
    <v-row v-else class="align-center justify-center ma-0 pt-5">
      <v-btn color="primary" width="130" @click="handleSubmit(updateSubject)">Cập nhật môn học</v-btn>
    </v-row>
    </ValidationObserver>
  </v-container>
</template>

<script>
import SubjectContent from "@/components/subject/SubjectContent.vue";
import SubjectSeo from "@/components/subject/SubjectSeo.vue";
import SubjectSeoEn from "@/components/subject/SubjectSeoEn.vue";

import { mapState } from "vuex";
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import { SET_LOADING } from "@/store/loading.module";
import {
  GET_DETAIL_SUBJECT,
  UPDATE_SUBJECT,
  SAVE_SUBJECT,
  SET_DEFAULT_SUBJECT,
} from "@/store/subject.module";
import { SUCCESS, ERROR } from "@/store/alert.module";

export default {
  data() {
    return {
      id: "",
      isCreate: false,
      tabIndex: 0,
      subject: {
        id:'',
        name:'',
        status:'',
        order:'',
        img:'',
        slug:'',
        seo_name:'',
        seo_key:'',
        seo_description:'',
        seo_slug_en:'',
        seo_description_en:'',
        seo_key_en:'',
        seo_name_en:'',
        name_en:'',
      },
      items: [{ id: 0, tab: "Thông tin chủ đề" },
              { id: 1, tab: "SEO môn học" },
              { id: 2, tab: "SEO môn học tiếng anh" },
      ],
      headers: [
        {
          text: "id",
          value: "id",
        },
        { text: "Tên Chuyên mục", value: "name" },
      ],
    };
  },
  components: {
    SubjectContent,
    SubjectSeo,
    SubjectSeoEn
  },
  computed: {
    ...mapState({
      detailSubject: (state) => state.subject.subject,
    }),
  },
  watch: {
    detailSubject: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.subject = newVal;
      },
    },
  },
  created() {
    this.id = this.$route.query.id;
  },
  mounted() {
    this.$store.dispatch(SET_DEFAULT_SUBJECT, [{ title: "Sửa môn học" }]);
    if (this.id) {
      this.isCreate = false;
      this.$store.dispatch(SET_BREADCRUMB, [{ title: "Sửa môn học" }]);

      this.$store.dispatch(SET_LOADING, true);
      this.$store
        .dispatch(GET_DETAIL_SUBJECT, { id: this.id })
        .then(() => {
          this.$store.dispatch(SET_LOADING, false);
        })
        .catch(() => {
          this.$store.dispatch(SET_LOADING, false);
        });
    } else {
      this.isCreate = true;
      this.$store.dispatch(SET_BREADCRUMB, [{ title: "Thêm môn học" }]);
    }
  },
  methods: {
    updateSubject() {
      let payload = {
        id: this.subject.id,
        name: this.detailSubject.name,
        act: this.detailSubject.status ? 1 : 0,
        ord: this.detailSubject.order,
        img:this.detailSubject.img,
        slug:this.detailSubject.slug,
        name_en:this.detailSubject.name_en,
        seo_name:this.detailSubject.seo_name,
        seo_key:this.detailSubject.seo_key,
        seo_description:this.detailSubject.seo_description,
        seo_name_en:this.detailSubject.seo_name_en,
        seo_key_en:this.detailSubject.seo_key_en,
        seo_description_en:this.detailSubject.seo_description_en,
        seo_slug_en:this.detailSubject.seo_slug_en,
      };
      this.$store.dispatch(SET_LOADING, true);
      this.$store
        .dispatch(UPDATE_SUBJECT, payload)
        .then((data) => {
          if (data.status) {
            this.$store.dispatch(SUCCESS, "Cập nhật môn học thành công!", {
              root: true,
            });
            this.$router.go(-1);
          } else {
            if(data.errorCode == 424){
              this.$store.dispatch(ERROR, data.message, {
                root: true,
              });
            }else {
              this.$store.dispatch(ERROR, "Cập nhật môn học thất bại!", {
                root: true,
              });
            }
          }
          this.$store.dispatch(SET_LOADING, false);
        })
        .catch(() => {
          this.$store.dispatch(ERROR, "Cập nhật môn học thất bại!", {
            root: true,
          });
          this.$store.dispatch(SET_LOADING, false);
        });
    },
    saveSubject() {
      let payload = {
        name: this.detailSubject.name,
        act: this.detailSubject.status ? 1 : 0,
        ord: this.detailSubject.order,
        slug: this.detailSubject.slug,
        name_en: this.detailSubject.name_en,
        seo_name:this.detailSubject.seo_name,
        seo_key:this.detailSubject.seo_key,
        seo_description:this.detailSubject.seo_description,
        seo_name_en:this.detailSubject.seo_name_en,
        seo_key_en:this.detailSubject.seo_key_en,
        seo_description_en:this.detailSubject.seo_description_en,
        seo_slug_en:this.detailSubject.seo_slug_en,
      };
      this.$store.dispatch(SET_LOADING, true);
      this.$store
        .dispatch(SAVE_SUBJECT, payload)
        .then((data) => {
          if (data.status) {
            this.$store.dispatch(SUCCESS, "Thêm môn học thành công!", {
              root: true,
            });
            this.$router.go(-1);
          } else {
            this.$store.dispatch(ERROR, "Thêm môn học thất bại!", {
              root: true,
            });
          }
          this.$store.dispatch(SET_LOADING, false);
        })
        .catch(() => {
          this.$store.dispatch(ERROR, "Thêm môn học thất bại!", { root: true });
          this.$store.dispatch(SET_LOADING, false);
        });
    },
  },
};
</script>

<style lang="scss">
.tab-detail {
  margin-top: 15px;
}
</style>
